import { render } from "./slider-widget.vue?vue&type=template&id=0276ebfc&scoped=true&ts=true"
import script from "./slider-widget.vue?vue&type=script&lang=ts"
export * from "./slider-widget.vue?vue&type=script&lang=ts"

import "./slider-widget.vue?vue&type=style&index=0&id=0276ebfc&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0276ebfc"]])

export default __exports__